<template>
  <div class="lists nano" ref="lists">
    <div class="nano-content" ref="listsContent">
      <song-item
        v-for="(item, key) in lists"
        :current="current"
        :index="key"
        :key="key"
        :obj="item"
        :isPlaying="isPlaying"
        @songClick="on_song_click"
      />
    </div>
  </div>
</template>

<script>
import songItem from "./components/song-item/index.vue";
import "./index.scss";
export default {
  inject: ["data", "comps"],
  computed: {
    lists() {
      return this.data.lists;
    },
  },
  components: {
    songItem,
  },
  data() {
    return {
      current: 0,
      isPlaying: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.init();
    }, 1000);
  },
  methods: {
    init() {
      this.event_handle();
      setTimeout(() => {
        $(this.$refs.lists).nanoScroller();
      }, 1000);
    },
    event_handle() {
      let VAudioObject = this.comps().controls.VAudioObject;
      VAudioObject.on("pause", () => {
        this.isPlaying = false;
      })
        .on("play", () => {
          this.isPlaying = true;
        })
        .on("ended", () => {
          if (this.current < this.lists.length - 1) {
            this.on_song_click(this.current + 1);
          } else {
            VAudioObject.set_current_time(0);
            VAudioObject.play();
            setTimeout(() => {
              VAudioObject.pause();
            }, 400);
          }
        });
    },
    on_song_click(index) {
      this.comps().controls.load_audio(this.lists[index].audioUri, true);
      this.comps().lyrics.load_lyrics(this.lists[index].lrcUri);
      this.current = index;
    },
  },
};
</script>
